<template>
  <div class="c-filter-part">
    <div class="filter-part" :key="'filter-item' + filter.selectedValues.length">
      <div class="filter-part__title" @click="openCollapse()"
        v-if="!filter.hideHeader">
        <span>
          {{ filter.title }}
        </span>
        <i :class="collapseIsOpen ? 'icon-arrow-up' : 'icon-arrow-down'"></i>
      </div>
      <div v-if="collapseIsOpen">
        <FilterItem :filter="filter" />
      </div>
    </div>
  </div>
</template>

<script>
import "vue-slider-component/theme/antd.css";
import FilterItem from "./FilterItem";

export default {
  name: "FilterPart",

  components: {
    FilterItem,
  },

  props: ["filter"],

  data() {
    return {
      collapseIsOpen: true
    }
  },

  methods: {
    openCollapse() {
      this.collapseIsOpen = !this.collapseIsOpen
    },
  },
};

</script>

<style lang="scss">
@import "../style/modules/_filterPart.scss";
</style>
